// FileUpload
import FileUpload from '../../components/cm-file-upload/index';
import hud from './hud.js';
// 文件-服务
export default {
  /**
   * 选择文件
   *
   * @param type 类型 image、audio、video、file
   * @param count 数量
   */
  choose(type = 'image', count = 1) {
    return new Promise((resolve, reject) => {
      const types = ['image', 'audio', 'video', 'file','','pdf'];
      if (types.indexOf(type) == -1) {
        const message = '不支持此文件：' + type;
        reject(message);
        hud.alert(message);
      }
      FileUpload({
        type: type,
        count: count,
        callback: res => {
          if (typeof res == 'string') {
            reject(res);
            hud.alert(res);
          } else {
            resolve(res);
          }
        }
      });
    });
  },
  /**
   * 下载文件
   *
   * @param filePath 文件下载地址
   * @param fileName 文件名称
   */
  download(filePath, fileName){
    const that = this
    fetch(filePath).then(res => res.blob()).then(blob => {
      that.downloadFile(blob,fileName)
    }).catch(res=>{
      window.open(filePath)
    })
  },
  downloadFile(blob,fileName){
    const a = document.createElement('a');
    document.body.appendChild(a)
    a.style.display = 'none'
    // 使用获取到的blob对象创建的url
    const url = window.URL.createObjectURL(blob);
    a.href = url;
    a.download = fileName;
    a.click();
    document.body.removeChild(a)
    window.URL.revokeObjectURL(url);
  },
  base64toBlob(base64Data) {
    let arr = base64Data.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], {
        type: mime
    })
}
}



// WEBPACK FOOTER //
// ./src/assets/plugin/prototypes/modules/file.js